import React from 'react'
import PT from 'prop-types'
import cx from 'classnames'
import EnhancedCheckbox from '@vimcar/shared-components/components/EnhancedCheckbox'
import linkStore from '@vimcar/shared-utils/linkStore'

import i18n from '#utils/i18n'
import mkStore from './store'
import styles from './styles.css'

const tp = i18n.prefix('components.ProfilePreferences')

const NotificationsPreferences = ({
  className,
  disabled,
  store,
  titleClassName,
}) => (
  <section className={cx(className, styles.notificationPreferences)}>
    <h3 className={titleClassName}>{tp('notification-settings')}</h3>
    <div className={styles.row}>
      <label className={styles.label}>
        <EnhancedCheckbox
          checked={store.emailChecked}
          className={styles.checkbox}
          disabled={disabled}
          onChange={store.handleEmailChange}
          />
        {tp('email-notifications')}
      </label>
    </div>
    {store.showPushOptions && (
      <div className={styles.row}>
        <label className={styles.label}>
          <EnhancedCheckbox
            checked={store.pushChecked}
            className={styles.checkbox}
            disabled={disabled}
            onChange={store.handlePushChange}
            />
          {tp('push-notifications')}
        </label>
      </div>
    )}
  </section>
)

NotificationsPreferences.propTypes = {
  className: PT.string,
  disabled: PT.bool,
  store: PT.shape({
    emailChecked: PT.bool.isRequired,
    handleEmailChange: PT.func.isRequired,
    handlePushChange: PT.func.isRequired,
    pushChecked: PT.bool.isRequired,
    showPushOptions: PT.bool,
  }),
  titleClassName: PT.string,
}

export default linkStore(mkStore, NotificationsPreferences)
